import { RootState } from '../store';

export const useCanTrackInteractions = () => (state: RootState) => {
  return state.cookieConsent.consent.analytics || state.cookieConsent.consent.necessary;
};